<template>
  <div class="app-container">
    <div class="head-container">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreate">提生产需求</el-button>
      <el-select v-model="query.supplierId" clearable placeholder="供应商" size="small" style="width:160px;margin-left:8px;" @change="reload">
        <el-option v-for="s in supplierOptions" :key="s.id" :label="s.supplierName" :value="s.id" />
      </el-select>
      <el-select v-model="query.status" clearable placeholder="状态" size="small" style="width:120px;margin-left:8px;" @change="reload">
        <el-option label="生产中" value="PRODUCING" />
        <el-option label="已发货" value="SHIPPED" />
        <el-option label="已完成" value="COMPLETED" />
        <el-option label="已取消" value="CANCELLED" />
      </el-select>
      <el-input v-model="query.demandNo" clearable placeholder="需求单号" size="small" style="width:180px;margin-left:8px;" @keyup.enter.native="reload" />
      <el-button icon="el-icon-search" size="small" style="margin-left:8px;" @click="reload">查询</el-button>
    </div>

    <el-table v-loading="loading" :data="list" size="small" border style="width:100%;margin-top:12px;">
      <el-table-column prop="demandNo" label="需求单号" min-width="170" show-overflow-tooltip />
      <el-table-column prop="supplierName" label="供应商" width="110" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row.status)" size="mini">{{ scope.row.statusLabel || statusLabel(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="totalDemandQty" label="需求数" width="80" align="center" />
      <el-table-column prop="totalReceivedQty" label="实收数" width="80" align="center" />
      <el-table-column prop="stockInBatchNo" label="入库批次" min-width="150" show-overflow-tooltip />
      <el-table-column prop="operatorName" label="创建人" width="90" />
      <el-table-column prop="createTime" label="创建时间" width="160" />
      <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip />
      <el-table-column label="操作" width="220" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openDetail(scope.row)">详情</el-button>
          <el-button
            v-if="scope.row.status === 'PRODUCING' || scope.row.status === 'SHIPPED'"
            type="text"
            size="mini"
            @click="openReceive(scope.row)"
          >确认收货</el-button>
          <el-button
            v-if="scope.row.status === 'PRODUCING'"
            type="text"
            size="mini"
            @click="doShip(scope.row)"
          >标已发货</el-button>
          <el-button
            v-if="scope.row.status === 'PRODUCING' || scope.row.status === 'SHIPPED'"
            type="text"
            size="mini"
            style="color:#f56c6c;"
            @click="doCancel(scope.row)"
          >取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:12px;text-align:right;"
      layout="total, prev, pager, next, sizes"
      :current-page="query.page + 1"
      :page-size="query.size"
      :total="total"
      @current-change="(p) => { query.page = Math.max(p - 1, 0); loadList() }"
      @size-change="(s) => { query.size = s; query.page = 0; loadList() }"
    />

    <el-dialog title="提生产需求" :visible.sync="createVisible" width="860px" :close-on-click-modal="false">
      <el-form label-width="100px" size="small">
        <el-form-item label="供应商" required>
          <el-select v-model="createForm.supplierId" filterable placeholder="选择供应商" style="width:100%;">
            <el-option v-for="s in supplierOptions" :key="s.id" :label="s.supplierName + ' (' + s.supplierCode + ')'" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="createForm.remark" type="textarea" :rows="2" maxlength="512" />
        </el-form-item>
        <el-form-item label="生产明细" required>
          <div v-for="(item, idx) in createForm.items" :key="'c-' + idx" class="line-row">
            <el-select v-model="item.ruleId" filterable placeholder="印章底部" style="width:220px;margin-right:8px;">
              <el-option v-for="c in ruleOptions" :key="c.id" :label="c.ruleName + ' (' + c.ruleCode + ')'" :value="c.id" />
            </el-select>
            <el-select v-model="item.handleId" filterable placeholder="手柄" style="width:140px;margin-right:8px;">
              <el-option v-for="h in handleOptions" :key="h.id" :label="h.handleName" :value="h.id" />
            </el-select>
            <el-input-number v-model="item.demandQty" :min="1" :max="999999" style="width:120px;margin-right:8px;" />
            <el-button type="text" style="color:#f56c6c;" @click="removeCreateLine(idx)">删除</el-button>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addCreateLine">添加一行</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="createVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="creating" @click="submitCreate">提交需求</el-button>
      </span>
    </el-dialog>

    <el-dialog title="需求详情" :visible.sync="detailVisible" width="720px">
      <el-descriptions v-if="detail" :column="2" size="small" border>
        <el-descriptions-item label="单号">{{ detail.demandNo }}</el-descriptions-item>
        <el-descriptions-item label="供应商">{{ detail.supplierName }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detail.statusLabel || statusLabel(detail.status) }}</el-descriptions-item>
        <el-descriptions-item label="需求合计">{{ detail.totalDemandQty }}</el-descriptions-item>
        <el-descriptions-item label="实收合计">{{ detail.totalReceivedQty }}</el-descriptions-item>
        <el-descriptions-item label="入库批次">{{ detail.stockInBatchNo || '—' }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{ detail.shippedTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="完成时间" :span="2">{{ detail.completedTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || '—' }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="detailItems" size="small" border style="margin-top:12px;">
        <el-table-column prop="ruleName" label="印章底部" min-width="120" />
        <el-table-column prop="handleName" label="手柄" width="100" />
        <el-table-column prop="demandQty" label="需求数" width="80" align="center" />
        <el-table-column prop="receivedQty" label="实收数" width="80" align="center" />
        <el-table-column label="进货价" width="100" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.purchasePrice != null">{{ Number(scope.row.purchasePrice).toFixed(4) }}</span>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="确认收货入库" :visible.sync="receiveVisible" width="720px" :close-on-click-modal="false">
      <el-alert title="填写实际收到数量后将自动生成入库单并完成该需求。" type="info" :closable="false" show-icon style="margin-bottom:12px;" />
      <el-table :data="receiveItems" size="small" border>
        <el-table-column prop="ruleName" label="印章底部" min-width="120" />
        <el-table-column prop="handleName" label="手柄" width="100" />
        <el-table-column prop="demandQty" label="需求数" width="80" align="center" />
        <el-table-column label="实收数" width="140" align="center">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.receivedQty" :min="0" :max="999999" size="mini" />
          </template>
        </el-table-column>
      </el-table>
      <el-input v-model="receiveRemark" type="textarea" :rows="2" placeholder="备注（可选）" style="margin-top:12px;" maxlength="512" />
      <span slot="footer">
        <el-button size="small" @click="receiveVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="receiving" @click="submitReceive">确认入库</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchEnabledSealSuppliers,
  fetchSealRules,
  fetchEnabledSealHandles,
  fetchSealProduceDemands,
  fetchSealProduceDemandDetail,
  createSealProduceDemand,
  shipSealProduceDemand,
  receiveSealProduceDemand,
  cancelSealProduceDemand
} from '@/api/h5-admin-seal-stock'

export default {
  name: 'H5AdminSealProduce',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: { page: 0, size: 10, supplierId: null, status: null, demandNo: '' },
      supplierOptions: [],
      ruleOptions: [],
      handleOptions: [],
      createVisible: false,
      creating: false,
      createForm: { supplierId: null, remark: '', items: [{ ruleId: null, handleId: null, demandQty: 1 }] },
      detailVisible: false,
      detail: null,
      detailItems: [],
      receiveVisible: false,
      receiving: false,
      receiveDemandId: null,
      receiveItems: [],
      receiveRemark: ''
    }
  },
  created() {
    this.loadOptions().then(() => this.loadList())
  },
  methods: {
    statusLabel(code) {
      const map = { PRODUCING: '生产中', SHIPPED: '已发货', COMPLETED: '已完成', CANCELLED: '已取消' }
      return map[code] || code || '—'
    },
    statusTagType(code) {
      if (code === 'PRODUCING') return 'warning'
      if (code === 'SHIPPED') return ''
      if (code === 'COMPLETED') return 'success'
      return 'info'
    },
    loadOptions() {
      return Promise.all([
        fetchEnabledSealSuppliers().then((res) => {
          this.supplierOptions = Array.isArray(res.data) ? res.data : []
        }),
        fetchSealRules({ page: 0, size: 200, status: 1 }).then((res) => {
          const data = (res && res.data) || {}
          this.ruleOptions = data.content || []
        }),
        fetchEnabledSealHandles().then((res) => {
          this.handleOptions = Array.isArray(res.data) ? res.data : []
        })
      ]).catch(() => {})
    },
    reload() {
      this.query.page = 0
      this.loadList()
    },
    loadList() {
      this.loading = true
      fetchSealProduceDemands({
        page: this.query.page,
        size: this.query.size,
        supplierId: this.query.supplierId || undefined,
        status: this.query.status || undefined,
        demandNo: this.query.demandNo || undefined
      })
        .then((res) => {
          const data = (res && res.data) || {}
          this.list = data.content || []
          this.total = data.totalElements || 0
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    openCreate() {
      this.loadOptions().then(() => {
        this.createForm = {
          supplierId: (this.supplierOptions[0] && this.supplierOptions[0].id) || null,
          remark: '',
          items: [{ ruleId: null, handleId: null, demandQty: 1 }]
        }
        this.createVisible = true
      })
    },
    addCreateLine() {
      this.createForm.items.push({ ruleId: null, handleId: null, demandQty: 1 })
    },
    removeCreateLine(idx) {
      if (this.createForm.items.length <= 1) {
        this.$message.warning('至少保留一行')
        return
      }
      this.createForm.items.splice(idx, 1)
    },
    submitCreate() {
      if (!this.createForm.supplierId) {
        this.$message.warning('请选择供应商')
        return
      }
      const items = (this.createForm.items || []).filter((i) => i.ruleId && i.handleId && i.demandQty > 0)
      if (!items.length) {
        this.$message.warning('请填写生产明细')
        return
      }
      this.creating = true
      createSealProduceDemand({
        supplierId: this.createForm.supplierId,
        remark: this.createForm.remark,
        items
      })
        .then((res) => {
          const row = (res && res.data) || {}
          this.$message.success('已提交需求：' + (row.demandNo || ''))
          this.createVisible = false
          this.loadList()
        })
        .finally(() => {
          this.creating = false
        })
    },
    openDetail(row) {
      fetchSealProduceDemandDetail(row.id).then((res) => {
        this.detail = (res && res.data) || null
        this.detailItems = (this.detail && this.detail.items) || []
        this.detailVisible = true
      })
    },
    doShip(row) {
      this.$confirm('确认标记为已发货？', '提示', { type: 'warning' })
        .then(() => shipSealProduceDemand(row.id))
        .then(() => {
          this.$message.success('已标记发货')
          this.loadList()
        })
        .catch(() => {})
    },
    doCancel(row) {
      this.$confirm('确认取消该生产需求？', '提示', { type: 'warning' })
        .then(() => cancelSealProduceDemand(row.id))
        .then(() => {
          this.$message.success('已取消')
          this.loadList()
        })
        .catch(() => {})
    },
    openReceive(row) {
      fetchSealProduceDemandDetail(row.id).then((res) => {
        const detail = (res && res.data) || {}
        this.receiveDemandId = detail.id
        this.receiveRemark = ''
        this.receiveItems = (detail.items || []).map((it) => ({
          itemId: it.id,
          ruleName: it.ruleName,
          handleName: it.handleName,
          demandQty: it.demandQty,
          receivedQty: it.demandQty
        }))
        this.receiveVisible = true
      })
    },
    submitReceive() {
      if (!this.receiveDemandId) return
      const items = (this.receiveItems || []).map((i) => ({
        itemId: i.itemId,
        receivedQty: i.receivedQty
      }))
      const sum = items.reduce((a, b) => a + (b.receivedQty || 0), 0)
      if (sum <= 0) {
        this.$message.warning('实收合计需大于0')
        return
      }
      this.receiving = true
      receiveSealProduceDemand({
        demandId: this.receiveDemandId,
        remark: this.receiveRemark,
        items
      })
        .then((res) => {
          const row = (res && res.data) || {}
          this.$message.success('已入库，批次：' + (row.stockInBatchNo || ''))
          this.receiveVisible = false
          this.loadList()
        })
        .finally(() => {
          this.receiving = false
        })
    }
  }
}
</script>

<style scoped>
.line-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 8px;
}
</style>
